import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import { FormControlLabel, Switch } from '@mui/material';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { OrganizationsApi } from '../../api/clients/organizations/organizations.api';

const OrganizationFeatures = ({ orgId, features, setFeatures }) => {
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await OrganizationsApi.getOrganizationFeatures(orgId);
        const {
          showApprovalsPage = false,
          showCreatePaymentPage = false,
          showBusinessUnitsPage = false,
          showFacilityManagementPage = false,
          showBulkApproveDecline = true,
        } = res || {};

        setFeatures({
          showApprovalsPage,
          showCreatePaymentPage,
          showBusinessUnitsPage,
          showFacilityManagementPage,
          showBulkApproveDecline,
        });
      } catch (error) {
        console.error('Error fetching organization features:', error);
        toast.error('Failed to load organization features');
      }
    };
    if (orgId) {
      fetchData();
    }
  }, [orgId, setFeatures]);

  const updateOrganizationFeatures = async (value, key) => {
    const previousFeatures = { ...features };

    try {
      const newFeatures = { ...features, [key]: value };
      setFeatures(newFeatures);

      await OrganizationsApi.updateOrganizationFeatures(orgId, newFeatures);
      toast.success('Feature updated successfully');
    } catch (error) {
      console.error('Error updating organization features:', error);
      toast.error('Failed to update feature');
      setFeatures(previousFeatures);
    }
  };

  return (
    <GridContainer
      style={{ paddingTop: '30px', display: 'flex', flexDirection: 'column' }}>
      <GridItem xs={12} sm={12} md={12}>
        <h4>
          <b>Features</b>
        </h4>
        <br />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={features.showApprovalsPage}
              onChange={(e) =>
                updateOrganizationFeatures(
                  e.target.checked,
                  'showApprovalsPage',
                )
              }
              name='automated_ach_return_enabled'
              color='primary'
            />
          }
          label='Enable Approvals Page'
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={features.showCreatePaymentPage}
              onChange={(e) =>
                updateOrganizationFeatures(
                  e.target.checked,
                  'showCreatePaymentPage',
                )
              }
              name='automated_ach_return_enabled'
              color='primary'
            />
          }
          label='Enable Create Payment Page'
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={features.showBusinessUnitsPage}
              onChange={(e) =>
                updateOrganizationFeatures(
                  e.target.checked,
                  'showBusinessUnitsPage',
                )
              }
              name='automated_ach_return_enabled'
              color='primary'
            />
          }
          label='Enable Business Units Page'
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={features.showFacilityManagementPage}
              onChange={(e) =>
                updateOrganizationFeatures(
                  e.target.checked,
                  'showFacilityManagementPage',
                )
              }
              name='show_facility_management_page'
              color='primary'
            />
          }
          label='Enable Facility User Management'
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={features.showBulkApproveDecline}
              onChange={(e) =>
                updateOrganizationFeatures(
                  e.target.checked,
                  'showBulkApproveDecline',
                )
              }
              name='show_bulk_approve_decline'
              color='primary'
            />
          }
          label='Enable Bulk Approve/Decline'
        />
      </GridItem>
    </GridContainer>
  );
};

export default OrganizationFeatures;
